import { createFileRoute } from '@tanstack/react-router';
import { NewScanPage } from '@/features/scans/NewScanPage';
import { marketsQueryOptions } from '@/lib/market';
import { NewScanSearch } from '@/lib/search-schemas';

export const Route = createFileRoute('/_auth/scans/new')({
  validateSearch: NewScanSearch,
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(marketsQueryOptions()).catch(() => undefined);
  },
  component: NewScanPage,
});
